import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCatalogKey,
  ShopifyMarketCatalogKey,
  ShopifyMarketCatalogToCatalogKey,
  ShopifyMarketCatalogToMarketKey,
  ShopifyMarketCatalogToShopKey,
  ShopifyMarketKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { buildConnectionSpec, ConnectionModelSpecVersion } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyMarketCatalogKey,
  "2024-04": {
    name: "Shopify Market Catalog",
    graphQLTypename: "MarketCatalog",
    fields: [
      {
        name: "ID",
        key: `${ShopifyMarketCatalogKey}-system-id`,
        fieldType: FieldType.ID,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Catalog",
        fieldType: FieldType.BelongsTo,
        key: ShopifyMarketCatalogToCatalogKey,
        configuration: {
          relatedModelKey: ShopifyCatalogKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "catalogId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Market",
        fieldType: FieldType.BelongsTo,
        key: ShopifyMarketCatalogToMarketKey,
        configuration: {
          relatedModelKey: ShopifyMarketKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "marketId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyMarketCatalogToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "markets",
      resource: "market.catalogs",
      additionalSelection: "id",
    },
  },
};

export const ShopifyMarketCatalog = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
